module.exports = __webpack_public_path__ + "img/BANNER_REVISTA-01.b61f8c69.jpg";